<div class="itsl-course-info-box itsl-course-info-box__read-view">
    <CourseInfoBoxImage imageUrl={courseImageUrl} imageColour={courseColour} imageDescription={courseImageDescription} />
    <CourseInfoBoxContent
        {canAdminGeneral}
        description={courseDescription}
        {editPageUrl}
        i18n={i18n}
        {showTeachers}
        {teachers}
        title={courseTitle}
    />
    <slot name="custom" />
</div>

<script>
    import CourseInfoBoxContent from "./CourseInfoBoxContent.svelte";
    import CourseInfoBoxImage from "./CourseInfoBoxImage.svelte";

    export let canAdminGeneral;
    export let courseColour;
    export let courseDescription;
    export let courseTitle;
    export let courseImageDescription;
    export let courseImageUrl;
    export let editPageUrl;
    export let i18n;
    export let showTeachers;
    export let teachers;
</script>
